import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import { Content } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import { _adr } from "../../../address";
import FormBulk from "./formBulk";
import { useState } from "react";
import DCBulkResult from "./DCBulkResult";
import styles from "./DCBulk.module.scss";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function DCBulk() {
	const [t] = useTranslation("global");
	const location = useLocation();
	const formData = useSelector((state) => state);

	// const [bTable, setBTable] = useState([]);

	// const { convertDCFileToJson, completeDCPurchase } = useAPIFile();

	// const [frmDCBulk] = Form.useForm();

	// const [isLoading, setIsLoading] = useState(false);
	// const [isCompleted, setIsCompleted] = useState(false);

	// const [dc, setDc] = useState({
	// 	purchase: location?.state || null,
	// 	isPriceActive: false,
	// 	chargeList: [],
	// });

	// const [fileList, setFileList] = useState([]);

	// const props = {
	// 	onRemove: (file) => {
	// 		const index = fileList.indexOf(file);
	// 		const newFileList = fileList.slice();
	// 		newFileList.splice(index, 1);
	// 		setFileList(newFileList);
	// 	},
	// 	beforeUpload: (file) => {
	// 		setFileList([file]);
	// 		return false;
	// 	},
	// 	fileList,
	// };

	// const handleUpload = async () => {
	// 	setIsLoading(true);
	// 	const formData = new FormData();
	// 	fileList.forEach((file) => {
	// 		formData.append("file", file);
	// 	});

	// 	const response = await convertDCFileToJson(formData);
	// 	if (response) {
	// 		const updatedTable = response.map((item, key) => ({
	// 			key: key,
	// 			msisdn: item.msisdn,
	// 			amount: complexDigitToman(item.amount),
	// 			description: item.description,
	// 			result: "درحال پردازش...",
	// 		}));
	// 		setBTable(updatedTable);
	// 		processRecords(updatedTable);
	// 	}
	// 	setIsLoading(false);
	// 	setIsCompleted(true);
	// };

	// const processRecords = async (records) => {
	// 	for (const record of records) {
	// 		try {
	// 			const response = await completeDCPurchase({
	// 				msisdn: record.msisdn,
	// 				planid: process.env.REACT_APP_PLANID_CHARGE_WALLET_DC,
	// 				chargeamount: regexFormater(record.amount).removeComma(),
	// 			});
	// 			setBTable((prevTable) =>
	// 				prevTable.map((item) =>
	// 					item.key === record.key
	// 						? {
	// 								...item,
	// 								result: response && response.HasError ? <span style={{ color: "green" }}>موفق</span> : <span style={{ color: "red" }}>ناموفق</span>,
	// 						  }
	// 						: item,
	// 				),
	// 			);
	// 		} catch (error) {
	// 			setBTable((prevTable) => prevTable.map((item) => (item.key === record.key ? { ...item, result: "ناموفق" } : item)));
	// 		}
	// 	}
	// };

	const [bulk, setBulk] = useState({
		wallet: formData?.another?._currentUser?.walletAmount || 0,
		List: [],
		step: 1,
		calAmount: 0,
	});

	return (
		<div className="container-main container-dc">
			<div className="g-hold-title-of-page">
				<Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("directCharge.title") }]} />
				<div className="title-page">
					<h3>{t("directCharge.title")}</h3>
					<p></p>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main dc-container">
					<div className="g-format-page">
						<br />
						<div className="g-body-format-page">
							<div className="charge-container">
								<div className="holder-charge">
									<div className="holder-form">
										{bulk.step == 1 ? (
											<FormBulk styles={styles} bulk={bulk} setBulk={setBulk} />
										) : (
											<DCBulkResult styles={styles} bulk={bulk} setBulk={setBulk} />
										)}

										{/* {isCompleted && (
											<div className="holder-table">
												<Table
													className="tbl-normal"
													columns={cTable}
													locale={{
														emptyText: (
															<>
																<NotFound text={"رکوردی یافت نشد."} />
															</>
														),
													}}
													scroll={{ y: "100%" }}
													dataSource={bTable}></Table>
											</div>
										)} */}
									</div>
								</div>
							</div>
						</div>
						{/* <Loading isOpen={isLoading} /> */}
					</div>
				</Content>
			</div>
		</div>
	);
}

export default DCBulk;
